"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var jobRouter = {
  path: "/job",
  component: _layout.default,
  redirect: "/job/appmonitor",
  name: "job",
  alwaysShow: true,
  meta: {
    title: "任务管理",
    icon: "job"
  },
  children: [{
    path: "appmonitor",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/job/appmonitor"));
      });
    },
    name: "应用监控",
    meta: {
      title: "应用监控",
      icon: ""
    }
  }, {
    path: "jobInfo",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/job/jobInfo"));
      });
    },
    name: "任务管理",
    meta: {
      title: "任务管理",
      icon: ""
    }
  }, {
    path: "taskInstance",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/job/taskInstance"));
      });
    },
    name: "taskInstance",
    meta: {
      title: "任务实例",
      icon: ""
    }
  }, {
    path: "jobLog",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/job/jobLog"));
      });
    },
    name: "jobLog",
    meta: {
      title: "任务日志",
      icon: ""
    }
  }, {
    path: "asyncTaskManage",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/task/asyncTaskManage"));
      });
    },
    name: "AsyncTaskManage",
    meta: {
      title: "异步任务",
      icon: ""
    }
  }
  // {
  //   path: "dagTaskInstance",
  //   component: () => import("@/views/job/dagTaskInstance"),
  //   name: "dagTaskInstance",
  //   meta: { title: "调度工作流任务实例", icon: "" }
  // },
  // {
  //   path: "workflowInfo",
  //   component: () => import("@/views/job/workflowInfo"),
  //   name: "workflowInfo",
  //   meta: { title: "调度工作流管理", icon: "" }
  // },
  // {
  //   path: "dagWorkflowInstance",
  //   component: () => import("@/views/job/dagWorkflowInstance"),
  //   name: "dagWorkflowInstance",
  //   meta: { title: "调度工作流实例", icon: "" }
  // },
  // {
  //   path: "workflowInstanceDetails",
  //   component: () => import("@/views/job/components/workflowInstanceDetails"),
  //   name: "workflowInstanceDetails",
  //   meta: { title: "调度工作流实例详情" }
  // }
  ]
};
var _default = exports.default = jobRouter;